import { call, takeEvery } from 'redux-saga/effects';
import { changeUserPassword } from '../../../User_list/requests/change_user_password_request';
import { message_success, message_error } from '../../../../../components/Message';

function* changeUserPasswordRequest({ params }) {
    const { user_id, password } = params; const
        { result, msg, error } = yield call(changeUserPassword, user_id, password);
    result ? message_success(msg) : message_error(error.message);
}

export default function* changeUserPasswordSaga() {
    yield takeEvery('CHANGE_USER_PASSWORD_REQUEST', changeUserPasswordRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/change_user_password.saga.js